import { render, staticRenderFns } from "./viewAgreements.vue?vue&type=template&id=2cc87f90&"
import script from "./viewAgreements.vue?vue&type=script&lang=js&"
export * from "./viewAgreements.vue?vue&type=script&lang=js&"
import style0 from "./viewAgreements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports